import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { Route, Switch } from 'react-router-dom';
import { toJS } from 'mobx';
import OrdersList from '../LiveOrdersScreen/containers/OrdersList/OrdersList';
import { CallCenterOrderScreen } from '../OrderScreen';
import { CallCenterCheckoutScreen } from '../CheckoutScreen';
import CallCenterHeader from './containers/CallCenterHeader/CallCenterHeader';
import CallCenterTabs from './containers/CallCenterTabs/CallCenterTabs';
import { Table } from 'src/view/components/Table/Table';
import { SCREENS } from 'src/constants/screens';
import { useCallCenterContext } from '~/mobx/ordersStore/context';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import { ORDER_STATUS } from '~/constants/order';
import { TOrder } from '~/types/orders';
import CustomRoute from '~/view/components/CustomRoute/CustomRoute';
import { USER_PERMISSIONS } from '~/constants/user';

const CallCenter: React.FC = (): JSX.Element => {
  const { store: callCenterStore } = useCallCenterContext();

  const handleSelectOrder = useCallback((order: TOrder) => {
    if (order.order_status_code === ORDER_STATUS.DRAFT) {
      history.push(SCREENS.CALLCENTER_ORDER_EDIT(order.id), toJS(order));
    } else {
      history.push(SCREENS.CALLCENTER_ORDER(order.id), toJS(order));
    }
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <CallCenterHeader />
      <CallCenterTabs />

      <Table>
        <div className="d-flex flex-row flex-grow-1 pt-4">
          <OrdersList onSelectOrder={handleSelectOrder} store={callCenterStore} />
          <Switch>
            <CustomRoute
              exact
              permissions={USER_PERMISSIONS.ORDERS_EDIT}
              path={SCREENS.CALLCENTER_ORDER_EDIT(':id')}
              component={CallCenterCheckoutScreen}
            />
            <Route
              exact
              path={[
                SCREENS.CALLCENTER_ORDER(':id'),
                SCREENS.CALLCENTER_ORDER_LOGS(':id'),
                SCREENS.CALLCENTER_ORDER_TECHNICAL_LOGS(':id'),
                SCREENS.CALLCENTER_ORDER_CONTENT_LOGS(':id'),
                SCREENS.CALLCENTER_ORDER_TRANSACTION_LOGS(':id'),
              ]}
              component={CallCenterOrderScreen}
            />

            <Route exact path={SCREENS.CALLCENTER()}>
              <h2 className="family-medium text-size-24 color-dark color-gray2 mx-auto my-auto">{localeStore.t('order_not_selected')}</h2>
            </Route>
          </Switch>
        </div>
      </Table>
    </div>
  );
};

export default observer(CallCenter);
